import { createFileRoute, Link, notFound } from '@tanstack/react-router'
import { z } from 'zod'
import { ArticleContent } from '@/features/blog/components/ArticleContent'
import { getArticleBySlug } from '@/features/blog/articles'
import { enumsQueryOptions } from '@/api/accommodation/hooks'
import { buildArticleHead } from '@/lib/seo/articleHead'
import { Button } from '@/components/ui/button'

const articleParamsSchema = z.object({
  slug: z.string().min(1),
})

function ArticleNotFound() {
  return (
    <div className="container flex min-h-[50vh] flex-col items-center justify-center py-16 text-center">
      <h1 className="mb-2 text-2xl font-semibold text-slate-700">Článek nenalezen</h1>
      <p className="mb-6 max-w-sm text-slate-500">Tento článek neexistuje nebo byl odstraněn.</p>
      <Button asChild>
        <Link to="/inspirace">Zpět na inspiraci</Link>
      </Button>
    </div>
  )
}

export const Route = createFileRoute('/_layout/inspirace/$slug')({
  component: ArticlePage,
  notFoundComponent: ArticleNotFound,
  params: {
    parse: (params) => articleParamsSchema.parse(params),
    stringify: (params) => ({ slug: params.slug }),
  },
  loader: ({ context, params }) => {
    const article = getArticleBySlug(params.slug)
    if (!article) throw notFound()
    // Prefetch enums so the `::nabidky` directive resolves a region filter on
    // its first fetch (not awaited — the article renders without it).
    void context.queryClient.query({
      ...enumsQueryOptions(),
      staleTime: 'static',
    })
    return article
  },
  head: ({ loaderData }) => (loaderData ? buildArticleHead(loaderData.meta) : {}),
})

function ArticlePage() {
  const article = Route.useLoaderData()
  return <ArticleContent article={article} />
}
